<template>
    <div class="mb-20">
        <timezone-form></timezone-form>
        <student-bio></student-bio>
        <cards-list class="mx-10"></cards-list>
    </div>
</template>

<script>
import TimezoneForm from '../TimezoneForm.vue';
import StudentBio from './StudentBio.vue';
import CardsList from '../payment/CardsList.vue';

export default {
  components: { TimezoneForm, StudentBio, CardsList },

};
</script>

<style>

</style>
